function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTrack = function SvgTrack(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M17.833 7.834c0-.917-.75-1.667-1.666-1.667h-2.5v1.667h2.5v2.208l-2.9 3.625h-2.934V9.5H7a3.332 3.332 0 0 0-3.333 3.334v2.5h1.666c0 1.383 1.117 2.5 2.5 2.5 1.384 0 2.5-1.117 2.5-2.5h3.734l3.766-4.709V7.834Zm-10 8.333A.836.836 0 0 1 7 15.334h1.667a.836.836 0 0 1-.834.833Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M6.167 7h4.166v1.667H6.167V7Zm11.666 5.833a2.497 2.497 0 0 0-2.5 2.5c0 1.384 1.117 2.5 2.5 2.5 1.384 0 2.5-1.116 2.5-2.5 0-1.383-1.116-2.5-2.5-2.5Zm0 3.334a.836.836 0 0 1-.833-.834c0-.458.375-.833.833-.833.459 0 .834.375.834.833a.836.836 0 0 1-.834.834Z"
  }));
};
export default SvgTrack;